import styled, { css } from "styled-components";

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin: 35px;
  padding: 25px 35px;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 8px;
  min-height: calc(100vh - 80px - calc(35px * 2));

  @media (max-width: 768px) {
    margin: 72px 16px;
    padding: 24px 19px;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
`;

export const Divider = styled.div`
  width: 100%;
  border: 1px solid rgba(0, 0, 0, 0.05);
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 17px;
  border-bottom: 1px dashed rgba(0, 0, 0, 0.1);

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
`;

export const HeaderInfos = styled.div`
  display: flex;
  flex-direction: column;
`;

export const HeaderTitle = styled.h1`
  color: ${({ theme }) => theme.colors.blue};
  font-size: 24px;
  line-height: 37px;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 20px;
    line-height: 33px;
  }
`;

export const HeaderSubtitle = styled.h2`
  color: ${({ theme }) => theme.colors.gray};
  font-size: 16px;
  line-height: 24px;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 14px;
    line-height: 22px;
  }
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 25px;
  overflow: auto;
  height: 100%;
  width: 100%;
  margin-top: 34px;
`;

export const FilterWrap = styled.div``;

export const BoxPaddingContainer = styled.div`
  position: relative;
`;

export const BoxFilters = styled.div`
  display: flex;
  gap: 10px;
  width: 100%;
  max-width: 350px;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const BillsContentWrap = styled.div``;

export const FilterStatusWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;

  @media (max-width: 768px) {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
  }
`;

type FilterStatusProps = {
  active?: boolean;
};

export const FilterStatus = styled.div<FilterStatusProps>`
  padding: 8px 12px;
  width: max-content;
  border: 2px solid #f3f3f3;
  border-radius: 8px;
  background-color: transparent;
  font-family: "Mangueira";
  font-weight: 700;
  color: ${({ theme }) => theme.colors.blue};
  cursor: pointer;

  display: flex;
  align-items: center;
  justify-content: center;

  ${({ active }) =>
    active &&
    css`
      background-color: #0000ff;
      border: 2px solid #0000ff;
      color: #fff;
    `}

  @media (max-width: 768px) {
    width: 100%;
    box-sizing: border-box;
  }
`;

export const FilterUnit = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
  max-width: 410px;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 2px;
    max-width: 350px;
    margin-bottom: 8px;
  }
`;
